import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import UserModalEdit from './UserModalEdit';
import UserModalRemove from './UserModalRemove';
import AvatarRound from '../../../components/AvatarRound';

function UserList({ data }) {

  //Модальные окна
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalRemoveShow, setModalRemoveShow] = useState(false);
  const [modelSelected, setModelSelected] = useState([]);

  return (
    <>
      {modalEditShow === true && (
        <UserModalEdit show={modalEditShow} onHide={() => setModalEditShow(false)} model={modelSelected} />
      )
      }
      {modalRemoveShow === true && (
        <UserModalRemove show={modalRemoveShow} onHide={() => setModalRemoveShow(false)} model={modelSelected} />
      )
      }

      {data.map((model) => (
        <div key={model.ID_User} className="list_item mt-15" onClick={() => { setModelSelected(model); setModalEditShow(true) }}>
          <div>
            <AvatarRound img={model.Avatar} width={40} name={model.Name_User !== null ? model.Name_User.charAt(0) : 'F'} />
          </div>
          <div className='ml-10' style={{ width: '100%' }}>
            <div className='title'>{model.Name_User}</div>
            <div className='subtitle'>{model.Name_Role}</div>
          </div>
          <div className='end'>
            <button className="border-0 btn-transition btn btn-outline-danger" onClick={(e) => { e.stopPropagation(); setModelSelected(model); setModalRemoveShow(true) }}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        </div>
      ))}
    </>
  );
}

export default UserList;
